class MerchfoxProductGalleryInteractions {
  constructor(galleryElement) {
    this.galleryElement = galleryElement;
    this.lastTapTime = 0;
    this.tapTimer = null;
    this.pointerStart = null;
    this.tapDelay = 280;
    this.doubleTapDelay = 320;
    this.moveTolerance = 12;

    this.initialize();
  }

  initialize() {
    this.galleryElement.addEventListener(
      'pointerdown',
      this.handlePointerDown.bind(this)
    );

    this.galleryElement.addEventListener(
      'pointerup',
      this.handlePointerUp.bind(this)
    );

    this.galleryElement.addEventListener(
      'pointercancel',
      this.handlePointerCancel.bind(this)
    );

    this.galleryElement
      .querySelectorAll(
        '.product-gallery__media[data-media-type="image"]'
      )
      .forEach((mediaElement) => {
        mediaElement.style.touchAction = 'manipulation';
      });
  }

  getImageMedia(targetElement) {
    if (
      targetElement.closest(
        'button, a, input, select, textarea'
      )
    ) {
      return null;
    }

    return targetElement.closest(
      '.product-gallery__media[data-media-type="image"]'
    );
  }

  handlePointerDown(event) {
    const mediaElement = this.getImageMedia(
      event.target
    );

    if (!mediaElement) {
      return;
    }

    this.pointerStart = {
      x: event.clientX,
      y: event.clientY,
      time: Date.now(),
      mediaElement
    };
  }

  handlePointerUp(event) {
    if (!this.pointerStart) {
      return;
    }

    const mediaElement = this.getImageMedia(
      event.target
    );

    if (
      !mediaElement ||
      mediaElement !== this.pointerStart.mediaElement
    ) {
      this.pointerStart = null;
      return;
    }

    const horizontalMovement = Math.abs(
      event.clientX - this.pointerStart.x
    );

    const verticalMovement = Math.abs(
      event.clientY - this.pointerStart.y
    );

    if (
      horizontalMovement > this.moveTolerance ||
      verticalMovement > this.moveTolerance
    ) {
      this.pointerStart = null;
      return;
    }

    const currentTime = Date.now();
    const timeSinceLastTap =
      currentTime - this.lastTapTime;

    if (
      this.lastTapTime > 0 &&
      timeSinceLastTap <= this.doubleTapDelay
    ) {
      window.clearTimeout(this.tapTimer);

      this.tapTimer = null;
      this.lastTapTime = 0;

      this.addToWishlist();
    } else {
      this.lastTapTime = currentTime;

      window.clearTimeout(this.tapTimer);

      this.tapTimer = window.setTimeout(() => {
        this.openZoom(mediaElement);

        this.tapTimer = null;
        this.lastTapTime = 0;
      }, this.tapDelay);
    }

    this.pointerStart = null;
  }

  handlePointerCancel() {
    this.pointerStart = null;
  }

  openZoom(mediaElement) {
    const mediaZoomButton =
      mediaElement.querySelector(
        '[is="product-zoom-button"]'
      );

    const galleryZoomButton =
      this.galleryElement.querySelector(
        '.product-gallery__media-list-wrapper > .product-gallery__zoom [is="product-zoom-button"]'
      );

    const zoomButton =
      mediaZoomButton ||
      galleryZoomButton ||
      this.galleryElement.querySelector(
        '[is="product-zoom-button"]'
      );

    if (!zoomButton) {
      return;
    }

    zoomButton.click();
  }

  addToWishlist() {
    const wishlistButton =
      document.getElementById(
        'swym-atw-pdp-button'
      );

    if (!wishlistButton) {
      return;
    }

    wishlistButton.click();
  }
}

const initializeMerchfoxProductGalleryInteractions =
  () => {
    document
      .querySelectorAll(
        '.merchfox-product-page product-gallery[allow-zoom]'
      )
      .forEach((galleryElement) => {
        if (
          galleryElement.dataset
            .merchfoxInteractionsInitialized ===
          'true'
        ) {
          return;
        }

        galleryElement.dataset
          .merchfoxInteractionsInitialized = 'true';

        new MerchfoxProductGalleryInteractions(
          galleryElement
        );
      });
  };

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeMerchfoxProductGalleryInteractions,
    { once: true }
  );
} else {
  initializeMerchfoxProductGalleryInteractions();
}

document.addEventListener(
  'shopify:section:load',
  initializeMerchfoxProductGalleryInteractions
);